import { produce } from 'immer'
import { capitalize, findIndex, forEach, map, startCase } from 'lodash'
import { Status, TrialData } from '../apis/trial.api'
import { ActionName } from '../components/Actions'
import { LabelType } from '../components/Label'
import { TableHorizontalData } from '../components/TableHorizontal'
import { i18n } from '../i18n/i18n'

const trialStatusBadges: Record<Status, LabelType> = {
  'email unverified': 'dark',
  'email verified': 'warning',
  approved: 'success',
  rejected: 'gray',
  expired: 'danger',
  onboarded: 'success',
  closed: 'gray'
}

const ROLE_MAP = [
  { value: 'Manager', key: 'manager' },
  { value: 'Production or Inventory', key: 'production_inventory' },
  { value: 'Designer/Creator', key: 'designer_creator' },
  { value: 'Operations', key: 'operations' },
  { value: 'Sales & Marketing', key: 'sales_marketing' },
  { value: 'Executive', key: 'executive' },
  { value: 'Individual', key: 'individual' },
  { value: 'Other', key: 'other' }
]

export default {
  tableHorizontalData (
    trials: TrialData[]
  ): TableHorizontalData<TrialData>[] {
    forEach(trials, (trial: TableHorizontalData<TrialData>) => {
      const actions: ActionName[] = []
      if (trial.status === 'email verified') {
        actions.push('accept')
        actions.push('reject')
      } else if (trial.status === 'expired') {
        actions.push('onboard')
        actions.push('close')
      }
      trial.typeText = capitalize(startCase(trial.type))
      trial.badge = trialStatusBadges[trial.status]
      trial.actions = actions
    })
    return trials
  },

  updateStatus (
    trials: TableHorizontalData<TrialData>[],
    id: number,
    status: Status
  ) {
    return produce(trials, trials => {
      const index = findIndex(trials, { id })
      if (index === -1) return
      const trial = trials[index]
      trial.status = status
      trial.badge = trialStatusBadges[status]
      trial.actions = []
      trials.splice(index, 1, trials[index])
    })
  },

  roleSelectOptions () {
    return map(ROLE_MAP, role => {
      const translations = i18n('roles')
      const translatedName = translations[role.key]
      return {
        value: role.value,
        name: translatedName
      }
    })
  }
}
